export default __webpack_public_path__ + "static/media/Cloud.89945d0c.png";